export enum CustomerMeetingAccountState {
  NotActivated = 'not_activated',
  Basic = 'basic',
  Beyond = 'beyond',
  BeyondTrial = 'beyond_trial',
  LeadCapture = 'lead_capture',
}

export interface CustomerMeetingAccount {
  state: CustomerMeetingAccountState;
  numberOfSeatsTotal: number;
  trialEndsAt: string | null;
}
